import "@fontsource/montserrat";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/700.css";
import { createTheme } from "@mui/material/styles";

export const getAppTheme = (mode: "light" | "dark") =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: "#00e677b2",
      },
      secondary: {
        main: "#00974eb2",
      },
      background:
        mode === "light"
          ? {
              default: "#FFFFFF",
              paper: "#fdfdfdff",
            }
          : {
              default: "#0d1117",
              paper: "#161b22",
            },
      text:
        mode === "light"
          ? {
              primary: "#121212",
              secondary: "#292929ff",
            }
          : {
              primary: "#ffffff",
              secondary: "#e2e2e2",
            },
      divider: mode === "light" ? "#e2e2e2" : "#464646ff",
    },
    typography: {
      fontFamily: "'Montserrat', sans-serif",
      h1: { fontFamily: "'Montserrat', sans-serif" },
      h2: { fontFamily: "'Montserrat', sans-serif" },
      h3: { fontFamily: "'Montserrat', sans-serif" },
      body1: { fontFamily: "'Montserrat', sans-serif" },
      button: { fontFamily: "'Montserrat', sans-serif" },
    },
    shape: {
      borderRadius: 12,
    },
  });
